import i18n from 'i18next';

// credit3d2 로 변경되고 간편결제 / 카드 결제가 혼용되어 들어오는 환경에서
// 요코하마 구장의 요청으로 간편결제도 카드로 표기되도록 간편결제도 카드로 대체함.
const PaymentMethodEnum = {
  ETC: 0,
  CARD: 1,
  LINEPAY: 2,
  PAYCO: 3,
  KAKAOPAY: 4,
  PayPay: 5,
  AUPAY: 6,
  POINT: 7,
  DENAPAY: 8,
  properties: {
    0: i18n.t('MESSAGE_CARD'),
    1: i18n.t('MESSAGE_CARD'),
    2: 'LINEPAY',
    3: '페이코',
    4: '카카오페이',
    5: i18n.t('MESSAGE_PAYPAY'),
    6: 'au PAY',
    7: i18n.t('MESSAGE_POINTS'),
    8: 'DeNA Pay',
  },
};

// paymentMethod 가 credit 로 사용하던 코드 체계
// const PaymentMethodEnum = {
//   ETC: 0,
//   CARD: 1,
//   LINEPAY: 2,
//   PAYCO: 3,
//   KAKAOPAY: 4,
//   PayPay: 5,
//   AUPAY: 6,
//   POINT: 7,
//   properties: {
//     0: i18n.t('MESSAGE_EASY'),
//     1: i18n.t('MESSAGE_CARD'),
//     2: 'LINEPAY',
//     3: '페이코',
//     4: '카카오페이',
//     5: i18n.t('MESSAGE_PAYPAY'),
//     6: 'au PAY',
//     7: i18n.t('MESSAGE_POINTS'),
//   },
// };

export default PaymentMethodEnum;
